import React from 'react'
import ReactModal from "react-modal";
import { useModal } from "react-modal-hook";

export const Modal = ({ title, buttonText, Form, onSubmit, data}) => {
 
    const [showModal, hideModal] = useModal(() => (
        <ReactModal isOpen>
            <div className="uk-align-right">
                <span onClick={hideModal} className="uk-background-danger uk-align-right@s" uk-icon="close"></span>
            </div>
            <div className="">
                <div className="uk-grid ">
                    <div className="uk-flex-left">
                        <h3>{title}</h3>
                    </div>
                </div>
                <div className="">
                    <Form
                        onSubmit={onSubmit}
                        inputs={data}
                        hideModal={hideModal}
                    />
                </div>

            </div>


        </ReactModal>
    ));
    return <span className=" uk-text-large uk-button-link uk-padding-small" onClick={showModal}>
        {buttonText}</span>;
}
Modal.defaultProps = {
    title: "Modal",
    buttonText: "Show",
    onSubmit: (() => { }),
    user:{}
}
